<template>
      <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
    <div v-else class="">

        <Banner
            :background="(info.image) ? info.image.url: ''"
            :title="(!pgLoading) ? $t('app.directors') : ''"
            :subtitle="(!pgLoading) ? $t('app.directors') : ''">
        </Banner>

        <section class="team-area-02 pt-125 pb-20">
            <div class="container">

                <div v-if="!pgLoading" class="row">
                    <div class="col-xl-8 offset-xl-2">
                        <div
                            class="section-title text-center mb-75 pl-50 pr-50 wow fadeInUp2 animated" data-wow-delay=".1s">
                            <h6>
                               <span><i class="fas fa-heart"></i></span>
                               {{ $t('app.directors') }}
                            </h6>
                            <h2>{{ info.title }}</h2>
                            <p v-html="info.body"></p>
                        </div>
                    </div>
                </div>

                <div v-if="pgLoading" class="row">
                    <div v-for="(row, idx) in 8" 
                        :key="idx" 
                        class="col-xl-3 col-lg-6 col-md-6 mb-30 wow fadeInUp animated" data-wow-delay=".2s">
                        <div class="teams mb-30 webkit-animation webkit-100-240" style="height:300px"></div>
                    </div>
                </div>

                <div v-if="!pgLoading" class="row d-flex align-center justify-content-center">

                    <div v-for="(row, idx) in manager" 
                        :key="idx" 
                        class="col-xl-3 col-lg-6 col-md-6 mb-30 text-center wow fadeInUp animated" data-wow-delay=".2s">
                        <div class="teams white-bg mb-30 text-center">
                            <div class="teams__thumb pos-rel mb-30">
                                <div class="teams__thumb--img pos-rel">
                                    <img v-if="row.image" style="width: 100%;height: auto;" :src="row.image.url" alt="" loading="lazy"/>
                                </div>
                            </div>
                            <div class="teams__content text-center">
                                <h3 class="semi-02-title">
                                    {{ row.name }}
                                </h3>
                               <p>{{ row.position }}</p>
                            </div>
                        </div>
                    </div>


               </div>
                <div v-if="!pgLoading" class="row">

                    <div v-for="(row, idx) in rows" 
                        :key="idx" 
                        class="col-xl-3 col-lg-6 col-md-6 mb-30 wow fadeInUp animated" data-wow-delay=".2s">
                        <div class="teams white-bg mb-30">
                            <div class="teams__thumb pos-rel mb-30">
                                <div class="teams__thumb--img pos-rel">
                                    <img v-if="row.image" style="width: 100%;height: auto;" :src="row.image.url" alt="" loading="lazy"/>
                                </div>
                            </div>
                            <div class="teams__content text-center">
                                <h3 class="semi-02-title">
                                    {{ row.name }}
                                </h3>
                               <p>{{ row.position }}</p>
                            </div>
                        </div>
                    </div>


               </div>

            </div>
         </section>

    </div>
</template>

<script>
// import iziToast from 'izitoast';

export default {
    name: 'Directors',
    components: {
        Banner: () => import('@/components/Banner.vue'),
    },
    data(){
        return {
            locale: 'ar',
            pgLoading: true,
            info: '',
            rows: [],
            manager: [],

            currentPage: 1,
            itemsPerPage: 9,
            resultCount: 0,
            nextPage: 2,
            prevPage: 0,
        }
    },
    computed: {
        totalPages: function() {
            return Math.ceil(this.resultCount / this.itemsPerPage)
        }
    },
    mounted() {},
    created() {
        //  
        if(localStorage.getItem('locale')) {
            this.locale = localStorage.getItem('locale');
        }

        this.fetchData();    
    },
    methods: {
        //
        fetchData() {
            window.scrollTo(0,0);
            this.pgLoading = true;
            this.axios.defaults.headers.common = {
                'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
            };
            const options = {
                url: window.baseURL+'/teams',
                method: 'GET',
                data: {},
                params: {
                    locale: this.locale,
                    status: 'active',
                    paginate: 20,
                    page: this.currentPage
                }
            }
            this.$axios(options)
            .then(res => {
                this.pgLoading = false;
                this.manager = res.data.rows.slice(0,1);
                this.rows = res.data.rows.slice(1, );

                // info
                this.info = res.data.info;

                // pagination
                this.currentPage = res.data.paginate.current_page;
                //this.itemsPerPage = res.data.paginate.per_page;
                this.resultCount = res.data.paginate.total;
                this.nextPage = res.data.paginate.next_page;
                this.prevPage = res.data.paginate.prev_page;

            })
            .catch(() => { })
            .finally(() => { });
        },

        setPage: function(pageNumber) {
            this.currentPage = pageNumber;
            this.fetchData();
        },

    },
}
</script>